import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { event } from '../data/masterclass';
import { Countdown } from './Countdown';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="relative isolate overflow-hidden bg-ink" data-id="element-44" data-mp="9l375k8q6q7o">
      <img src={event.backdropUrl} alt="" aria-hidden="true" className="absolute inset-0 -z-10 h-full w-full object-cover opacity-70" data-id="element-45" data-mp="4mrt0xbedtjn" />
      <div className="absolute inset-0 -z-10 bg-ink/60" aria-hidden="true" data-id="element-46" data-mp="x9upzl0fdw7s" />

      <div className="mx-auto w-full max-w-7xl px-6 pb-20 pt-8 lg:px-10 lg:pb-24" data-id="element-47" data-mp="x8jj3cboo8cg">
        <img src={event.logoUrl} alt="Meet the Eatmons" className="h-20 w-20 object-contain sm:h-24 sm:w-24" data-id="element-48" data-mp="sde12olejdtn" />

        <div className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-49" data-mp="3d1sbr0oqzpup">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: EASE
        }} data-id="element-50" data-mp="381xm10gpl6b8">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-gold" data-id="element-51" data-mp="3j6o8rb5sq6lv">
              {event.dateLabel} at {event.timeLabel}
            </p>
            <h1 className="mt-3 font-display text-6xl font-bold uppercase leading-[0.92] text-white sm:text-7xl lg:text-8xl" data-id="element-52" data-mp="399jmlbbyab52">
              Unified <span className="text-gold" data-id="element-53" data-mp="3ebiqqnfilc32">Success</span>
              <span className="block" data-id="element-54" data-mp="30gzuyuu2t6tq">Masterclass</span>
            </h1>
            <p className="mt-5 font-display text-2xl font-medium uppercase tracking-wide text-white/70 sm:text-3xl" data-id="element-55" data-mp="358ho4wpuy345">
              with Curtis &amp; Spring Eatmon IV
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: EASE,
          delay: 0.1
        }} className="mt-14 flex w-full max-w-2xl flex-col items-center gap-6 border-t border-gold/20 pt-10" data-id="element-56" data-mp="2vietyt702j48">
            <Countdown data-id="element-57" data-mp="s2jn3wuh80ji" />
            <p className="flex items-center gap-2 text-sm text-white/55" data-id="element-58" data-mp="s332b5sqsatu">
              <ArrowRightIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-59" data-mp="nat6j94y4gjn" />
              Live on Zoom · Replay included
            </p>
          </motion.div>
        </div>
      </div>
    </header>;
}